import React from "react";
import { SelectInput } from "react-admin";
import dataProviderFactory from "../../dataProvider";
import { GET_LIST } from "react-admin";

export class CustomInputFilter extends React.Component {
  constructor(props) {
    super(props);
    this.offset = 0;
    this.state = { data: [] };
  }

  async getModelsData() {
    let data = [];
    const dataProvider = await dataProviderFactory("rest");
    const response = await dataProvider(GET_LIST, "vehicle_models", {
      pagination: {
        page: 1,
        perPage: 999
      },
      sort: { order: "asc", field: "order" }
    });

    response.data.map(function(item) {
      return data.push({ id: item.id, model_name: item.model_name });
    });

    return data;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.input.value !== this.props.input.value) {
      this.setState({ value: nextProps.input.value });
    }
  }

  async componentDidMount() {
    const dataItems = await this.getModelsData();
    const data = { data: dataItems };
    this.setState(data);
  }
  render() {
    return (
      <div>
        <span>
          <SelectInput
            source="vehicle_model_id"
            choices={this.state.data}
            {...this.rest}
            optionText="model_name"
            optionValue="id"
            allowEmpty={true}
            defaultValue={null}
          />
        </span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/selectboxfilter/custominputfilter.js